export function hslToHex(h, s, l) {
    s /= 100;
    l /= 100;

    let c = (1 - Math.abs(2 * l - 1)) * s,
        x = c * (1 - Math.abs((h / 60) % 2 - 1)),
        m = l - c / 2,
        r = 0,
        g = 0,
        b = 0;

    if (0 <= h && h < 60) {
        r = c;
        g = x;
        b = 0;
    } else if (60 <= h && h < 120) {
        r = x;
        g = c;
        b = 0;
    } else if (120 <= h && h < 180) {
        r = 0;
        g = c;
        b = x;
    } else if (180 <= h && h < 240) {
        r = 0;
        g = x;
        b = c;
    } else if (240 <= h && h < 300) {
        r = x;
        g = 0;
        b = c;
    } else if (300 <= h && h < 360) {
        r = c;
        g = 0;
        b = x;
    }
    // Having obtained RGB, convert channels to hex
    r = Math.round((r + m) * 255).toString(16);
    g = Math.round((g + m) * 255).toString(16);
    b = Math.round((b + m) * 255).toString(16);

    // Prepend 0s, if necessary
    if (r.length == 1)
        r = "0" + r;
    if (g.length == 1)
        g = "0" + g;
    if (b.length == 1)
        b = "0" + b;

    return "#" + r + g + b;
}

export const createPathAnimationKeyFrames = ({
    fill,
}) => {
    return {
        fill,
    };
};

export const createAnimationKeyFrames = ({
    perspective = 100,
    startX = 0,
    endX = 0,
    startY = 0,
    endY = 0,
    startZ = 0,
    endZ = 0,
    startOpacity = 0,
    endOpacity = 1,
    animationDuration = 1000,
    animationDelay = 0,
    startRotateX = 0,
    startRotateY = 0,
    startRotateZ = 0,
    startRotateAngle = 0,
    endRotateX = 0,
    endRotateY = 0,
    endRotateZ = 0,
    endRotateAngle = 0,
}) => {
    const translateKeyFrames = {
        '0%': {
            transform: `perspective(${perspective}) translate3d(${startX}px,${startY}px,${startZ}px) rotate3d(${startRotateX}, ${startRotateY}, ${startRotateZ}, ${startRotateAngle}deg) `,
            opacity: startOpacity,
        },
        '100%': {
            transform: `perspective(${perspective}) translate3d(${endX}px,${endY}px,${endZ}px) rotate3d(${endRotateX}, ${endRotateY}, ${endRotateZ}, ${endRotateAngle}deg) `,
            opacity: endOpacity,
        },
    };

    return {
        animationName: [translateKeyFrames],
        animationDuration: `${animationDuration}ms`,
        animationDelay: `${animationDelay}ms`,
        animationIterationCount: 1,
        animationFillMode: "both",
        transformOrigin: "center",
        perspectiveOrigin: "center",
    };
};